import { SEO } from "../components/common/SEO";
import { useLanguage } from "../context/LanguageProvider";
import { useSiteData } from "../context/SiteDataProvider";
import { pick, UI_STRINGS } from "../lib/i18n";

export default function Legal() {
    const { lang } = useLanguage();
    const { siteContent, contactInfo } = useSiteData();
    const disc = siteContent?.legal_disclaimer || {};

    return (
        <div data-testid="page-legal" className="bg-ink">
            <SEO
                title={pick(UI_STRINGS.misc.legal_link, lang)}
                description={pick(UI_STRINGS.misc.legal_short, lang)}
                lang={lang}
            />
            <section className="mx-auto max-w-3xl px-5 lg:px-8 py-16 md:py-24">
                <div className="eyebrow mb-3">
                    {pick(UI_STRINGS.misc.legal_link, lang)}
                </div>
                <h1 className="font-serif text-4xl md:text-5xl leading-tight text-neutral-50 mb-8">
                    {pick(disc.title, lang)}
                </h1>
                <div className="prose-mabs">
                    <p>{pick(disc.text, lang)}</p>

                    <p>
                        {pick(
                            {
                                fr: "Cabinet d'avocats Maître Mina Adja Bintou Sanou, avocate inscrite au Barreau du Québec (Canada) depuis 2020 et au Barreau du Burkina Faso depuis 2022.",
                                en: "Cabinet d'avocats Maître Mina Adja Bintou Sanou, attorney admitted to the Barreau du Québec (Canada) since 2020 and to the Bar of Burkina Faso since 2022.",
                            },
                            lang,
                        )}
                    </p>

                    {contactInfo && (
                        <>
                            <p>
                                <strong className="text-neutral-100">
                                    {pick(
                                        { fr: "Adresse : ", en: "Address: " },
                                        lang,
                                    )}
                                </strong>
                                {pick(contactInfo.address, lang)}
                            </p>
                            <p>
                                <strong className="text-neutral-100">
                                    {pick(
                                        {
                                            fr: "Courriel : ",
                                            en: "Email: ",
                                        },
                                        lang,
                                    )}
                                </strong>
                                {contactInfo.email_main}
                            </p>
                        </>
                    )}
                </div>
            </section>
        </div>
    );
}
